export enum TrackingVideoQualityEnum {
  LOW_QUALITY = 'lowQuality',
  MELLANMJOLK = 'mellanmjölk',
  LOW_QUALITY_SMDC = 'lowQualitysmdc',
  HIGH_QUALITY = 'highQuality',
  PPE = 'ppe',
}

export enum GaitEnum {
  TROT = 'trot',
  WALK = 'walk',
  CANTER = 'canter',
  TOLT = 'tolt',
  PACE = 'pace',
  UNKNOWN_GAIT = 'unknownGait',
  LEFT_CANTER = 'leftCanter',
  RIGHT_CANTER = 'rightCanter',
  STANDING_STILL = 'standingStill',
  BUCKING = 'bucking',
  TROCHA = 'trocha',
  PASO_FINO = 'pasoFino',
  TRANSITION = 'transition',
  GALLOP = 'gallop',
}

export enum AnalysisTypeEnum {
  STRAIGT = 'straight',
  LONGEING = 'longeing',
  SAVE = 'save',
}

export enum LongeingDirectionEnum {
  CLOCKWISE = 'clockwise',
  COUNTER_CLOCKWISE = 'counterclockwise',
  ANTI_CLOCKWISE = 'antiClockwise',
}
